export function setupPlainChat() {
    function load() {
        // eslint-disable-next-line sonarjs/disabled-resource-integrity
        const script = document.createElement("script");
        script.src = "https://chat.cdn-plain.com/index.js";
        script.type = "text/javascript";
        script.async = false;
        script.id = "plain-chat-loader";

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode?.insertBefore(script, firstScript);
    }

    if (document.readyState === "complete") {
        load();
    } else {
        window.addEventListener("load", load, false);
    }
}
